import { StringConst } from 'src/app/constants/const';
import { ExtraClinicInfo } from './general.model';

export class InformationClinics {
  clinicName: string;
  phone: string;
  address: string;
  zipCode: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  streeNo: string;
  facebookPage: string;
  twitterPage: string;
  instagramPage: string;
  webSitePage: string;
  medics: string;
  patientsPerDay: string;
  operationDays: string;
  extraClinicInfo: ExtraClinicInfo;

  // PARAMETROS PARA VISTA
  existFacebookPage: boolean;
  existTwitterPage: boolean;
  existInstagramPage: boolean;
  existWebSitePage: boolean;

  constructor() {
    this.clinicName = StringConst.empty;
    this.state = StringConst.empty;
    this.city = StringConst.empty;
    this.neighborhood = StringConst.empty;
    this.street = StringConst.empty;
    this.streeNo = StringConst.empty;
    this.zipCode = StringConst.empty;
    this.phone = StringConst.empty;
    this.facebookPage = StringConst.empty;
    this.twitterPage = StringConst.empty;
    this.instagramPage = StringConst.empty;
    this.webSitePage = StringConst.empty;
    this.address = StringConst.empty;
    this.medics = StringConst.empty;
    this.patientsPerDay = StringConst.empty;
    this.operationDays = StringConst.empty;
    this.extraClinicInfo = new ExtraClinicInfo();
    this.existFacebookPage = false;
    this.existTwitterPage = false;
    this.existInstagramPage = false;
    this.existWebSitePage = false;
  }
}
